var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tournaments-slider"},[_c('skelet-rectangle',{attrs:{"width":100000,"height":300}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }